/*global module, require*/

const defaults = require('./defaults'),
	envConfig = require('./production'),
	storageConfig = require('./aws'),
	config = {
		microsoftAppId: 'c12a3d54-d294-4a51-8cd3-4a48b6c7e6f2',
		CDNDistributionId: 'E2DSN2TFNHAYVD',
		legacyFreeUrl: 'https://mindmup-anon-prd.s3.amazonaws.com/map/',
		cognito: {
			cognitoIdentityPoolId: 'us-east-1:dfb3e6f5-dbc3-4110-94d0-68dcfee6c710',
			UserPoolId: 'us-east-1_2jtO6FSEB',
			ClientId: '2s28hgso1b2ra4qdkm7jebde02'
		}
	};
module.exports = Object.assign({}, defaults, storageConfig, envConfig, config);
